<template>
  <a :href="exportRoute" target="_blank">
    <label class="btn btn-success float-right" style="margin: 4px;">
      <i class="fa fa-file-excel-o mr-1"></i> Dados Bancários
    </label>
  </a>
</template>

<script>
import BankAccounts from '@/services/api/bl-bankaccounts'

export default {
  props: {
    entity: {
      type: [Object],
      required: true
    },

    http: {
      type: [Object],
      required: true
    }
  },

  data () {
    return {}
  },

  computed: {
    exportRoute () {
      return BankAccounts.exportRoute()
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/forms/Bl/ExportAccountsButton.vue